export const getPlacement = (align, isSubmenu = false) => {
    if (isSubmenu) {
        switch (align) {
            case 'right':
                return 'right-start';
            case 'left':
                return 'left-start';
            default:
                return 'right-start';
        }
    }
    switch (align) {
        case 'right':
            return 'bottom-start';
        case 'left':
            return 'bottom-end';
        default:
            return 'bottom-start';
    }
};
export const stopPropagation = (e) => {
    e.stopPropagation();
};
